import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../Avatar';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';
import { Hidden } from '../Table';
import Tenant from '../Tenant';
import { ITableColumn } from '../Table/types';

interface CreatePropertyDevelopersTableColumnsParams {
  propertyData: any;
  user: any;
  handleSetContactFormData: (contactId: string) => Promise<void>;
  onDeleteContact: (data: any) => void;
  PATHS: any;
  ICONS: any;
  variables: any;
  onRequestPhoneCall: (phone: any) => any;
  checkSparkDataAvailable: (propertyData: any, roleName: string) => boolean;
}

export const createPropertyDevelopersTableColumns = ({
  propertyData,
  user,
  handleSetContactFormData,
  onDeleteContact,
  PATHS,
  ICONS,
  variables,
  onRequestPhoneCall,
  checkSparkDataAvailable,
}: CreatePropertyDevelopersTableColumnsParams): ITableColumn[] => {
  return [
    {
      label: 'Contacts',
      sortable: true,
      accessor: 'firstname',
      cell: (data: any) => {
        return (
          <Link to={PATHS.CONTACTS_VIEW.replace(':id', data.id)}>
            <Tenant
              headline={`${data.firstname} ${data.lastname}`}
              avatar={
                <Avatar
                  badge={ICONS['Property Developer']}
                  url={data.profileImage}
                />
              }
            />
          </Link>
        );
      },
    },
    {
      xsHide: true,
      label: 'Role',
      cell: (data: any) => (
        <div style={{ display: 'flex' }}>
          {data.role === 'Property Developer'
            ? variables.propertyDeveloper
            : data.role}
          {data.isPrimaryContact === true ? (
            <div
              style={{
                display: 'flex',
                color: '#48C2BF',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 5,
              }}
            >
              <FontAwesomeIcon glyph="sun" weight="regular" size="small" />
            </div>
          ) : (
            <div />
          )}
        </div>
      ),
    },
    {
      label: 'Phone',
      accessor: 'phone',
      cell: (data: any) => onRequestPhoneCall(data.phone),
    },
    {
      xsHide: true,
      label: 'Email',
      accessor: 'email',
    },
    {
      cell: (data: any) => (
        <Hidden>
          {checkSparkDataAvailable(
            propertyData,
            user.roles[0].role.name
          ) ? null : (
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="pencil" weight="light" />}
              onClick={() => handleSetContactFormData(data.id)}
            />
          )}
          {user.roles[0].role.name === 'Admin' ||
          user.roles[0].role.name === 'Super Admin' ||
          user.roles[0].role.name === 'Property Developer' ? (
            <Button
              color="semantic"
              onClick={(e: any) =>
                data.isPrimaryContact === false
                  ? window.confirm(
                      `Are you sure you want to remove ${data.firstname} ${data.lastname} from this project?`
                    ) && onDeleteContact(data)
                  : alert(
                      'Please select other property developer as Primary property developer before deleting this property developer'
                    )
              }
              label={<FontAwesomeIcon glyph="trash" weight="light" />}
            />
          ) : null}
        </Hidden>
      ),
    },
  ];
};
